import { __decorate } from "tslib";
// Core
import { Component, Prop, Mixins } from 'vue-property-decorator';
// Extends
import AlertMixin from '@/helpers/vue_mixins/AlertMixin';
// Children
import BaseOverlayLoader from '@/components/v2/BaseOverlayLoader';
import FacebookPostThumb from '@/components/v3/FacebookPostThumb.vue';
import PageListPaginator from '@/components/facebook/PageListPaginator.vue';
// Models / Helpers
// Queries / Mutations
import FacebookPagePosts from '@/plugins/graphql/queries/v2/affiliate/facebook-page-posts.gql';
let FacebookPostPicker = class FacebookPostPicker extends Mixins(AlertMixin) {
    constructor() {
        super(...arguments);
        this.posts = [];
        this.paging = {};
        this.after = null;
        this.afterCursors = [];
    }
    isSelected(post) {
        return this.value.findIndex((value) => value.id === post.id) !== -1;
    }
    postClicked(post) {
        const index = this.value.findIndex((value) => value.id === post.id);
        if (index === -1 && this.value.length < 3) {
            this.value.push(post);
        }
        else if (index !== -1) {
            this.value.splice(index, 1);
        }
    }
    onNext() {
        this.after = this.paging.cursors.after;
        this.afterCursors.push(this.after);
        this.$apollo.queries.facebookPosts.refetch();
    }
    onPrevious() {
        this.after = this.afterCursors.pop();
        this.$apollo.queries.facebookPosts.refetch();
    }
};
__decorate([
    Prop({ type: Array, default: () => [] })
], FacebookPostPicker.prototype, "value", void 0);
FacebookPostPicker = __decorate([
    Component({
        components: {
            BaseOverlayLoader,
            FacebookPostThumb,
            PageListPaginator,
        },
        apollo: {
            facebookPosts: {
                query: FacebookPagePosts,
                variables() {
                    return {
                        appUuid: this.$store.state.appUUID,
                        after: this.after,
                        before: null,
                    };
                },
                update({ fetchFacebookPagePosts }) {
                    this.posts = fetchFacebookPagePosts.data;
                    this.paging = fetchFacebookPagePosts.paging;
                },
                skip() {
                    return !this.$store.state.appUUID;
                },
            },
        },
    })
], FacebookPostPicker);
export default FacebookPostPicker;
